import React, { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import SectionHeading from "./SectionHeading";
import PrimaryButton from "../../common/PrimaryButton";
import VolunteerFormModal from "../Modal/VolunteerFormModal";
import volunteer from "../../../Assets/Images/home/volunteer/Voulenter.webp";
import volunteers_bg from "../../../Assets/Images/home/volunteer/volunteers_bg.png";

// Dummy Data
const volunteerData = [
  {
    title: "Recognition and Fulfillment",
    description:
      "Gain valuable experience while making a real difference in your community. Our volunteers receive certificates of appreciation and build skills that enhance professional development.",
  },
  {
    title: "Why Join Us as a Volunteer?",
    description:
      "By volunteering, you gain real-world experience, expand your network, and create meaningful social impact through active participation in our diverse programs.",
  },
  {
    title: "Be Part of a Community",
    description:
      "Join a like-minded community working together to drive positive change and support impactful causes. Connect with people who share your passion for social justice.",
  },
];

const AFSAVolunteers = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleJoinClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="relative py-4  overflow-hidden">
        {/* Background with subtle pattern */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-20"
          style={{
            backgroundImage: `url(${volunteers_bg})`,
          }}
        >
          <div className="absolute inset-0 bg-white opacity-95"></div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-orange-100 rounded-full -translate-y-1/2 translate-x-1/2 -z-10"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-100 rounded-full translate-y-1/2 -translate-x-1/2 -z-10"></div>

        <div className="general-p-m">
          <div className="max-w-6xl mx-auto">
            {/* Section heading for mobile */}
            <div
              className="block md:hidden mb-8 text-center"
              data-aos="fade-up"
            >
              <SectionHeading
                title={" Become A Volunteer"}
                textAlign="center"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
              {/* Left: Image */}
              <div
                className="relative h-full flex items-center justify-center rounded-2xl overflow-hidden shadow-lg"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-orange-50 opacity-80 z-0"></div>
                <img
                  src={volunteer}
                  alt="Happy volunteers working together"
                  className="relative z-10 w-full h-full max-h-[500px] object-cover"
                />
              </div>

              {/* Right: Content */}
              <div
                className="flex flex-col h-full justify-center"
                data-aos="fade-left"
              >
                {/* Section heading for desktop */}
                <div className="hidden md:block mb-6">
                  <SectionHeading
                    title={" Become A Volunteer"}
                    textAlign="left"
                  />
                </div>

                {/* Accordion */}
                <div className="flex flex-col gap-4 mb-6">
                  {volunteerData.map((item, index) => (
                    <div
                      key={index}
                      className={`border rounded-xl p-5 bg-white transition-all duration-300 cursor-pointer hover:shadow-md ${
                        openIndex === index
                          ? "border-orange-400 bg-orange-50 shadow-sm"
                          : "border-gray-200 hover:border-gray-300"
                      }`}
                      onClick={() => toggleIndex(index)}
                    >
                      <div className="flex items-center justify-between">
                        <h3
                          className={`font-semibold transition-colors duration-200 text-lg ${
                            openIndex === index
                              ? "text-orange-600"
                              : "text-gray-800"
                          }`}
                        >
                          {item.title}
                        </h3>
                        <div className="flex-shrink-0 ml-3">
                          {openIndex === index ? (
                            <FiChevronDown className="text-orange-500 text-xl transition-transform duration-200" />
                          ) : (
                            <FiChevronRight className="text-gray-500 text-xl transition-transform duration-200 hover:text-gray-700" />
                          )}
                        </div>
                      </div>

                      {/* Smooth expanding content */}
                      <div
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${
                          openIndex === index
                            ? "max-h-40 opacity-100 mt-3"
                            : "max-h-0 opacity-0 mt-0"
                        }`}
                      >
                        <p className="text-gray-600 leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Button */}
                <div data-aos="fade-up" data-aos-delay="400">
                  <PrimaryButton
                    text="Join with us"
                    onClick={handleJoinClick}
                    className="whitespace-nowrap py-3 px-8 text-lg font-medium rounded-xl shadow-md hover:shadow-lg transition-shadow"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <VolunteerFormModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default AFSAVolunteers;

// import React, { useState } from "react";
// import { FiChevronDown, FiChevronRight } from "react-icons/fi";
// import SectionHeading from "./SectionHeading";
// import PrimaryButton from "../../common/PrimaryButton";
// import VolunteerFormModal from "../Modal/VolunteerFormModal";
// import volunteer from "../../../Assets/Images/home/volunteer/Voulenter.webp";
// import volunteers_bg from "../../../Assets/Images/home/volunteer/volunteers_bg.png";

// // Dummy Data
// const volunteerData = [
//   {
//     title: "Recognition and Fulfillment",
//     description:
//       "Gain valuable experience while making a real difference in your community. Our volunteers receive certificates of appreciation and build skills that enhance professional development.",
//   },
//   {
//     title: "Why Join Us as a Volunteer?",
//     description:
//       "By volunteering, you gain real-world experience, expand your network, and create meaningful social impact through active participation in our diverse programs.",
//   },
//   {
//     title: "Be Part of a Community",
//     description:
//       "Join a like-minded community working together to drive positive change and support impactful causes. Connect with people who share your passion for social justice.",
//   },
// ];

// const AFSAVolunteers = () => {
//   const [openIndex, setOpenIndex] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const toggleIndex = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const handleJoinClick = () => {
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <>
//       <section className="relative py-16 md:py-20 overflow-hidden">
//         {/* Background with subtle pattern */}
//         <div
//           className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-20"
//           style={{
//             backgroundImage: `url(${volunteers_bg})`,
//           }}
//         >
//           <div className="absolute inset-0 bg-white opacity-95"></div>
//         </div>

//         {/* Decorative elements */}
//         <div className="absolute top-0 right-0 w-40 h-40 bg-orange-100 rounded-full -translate-y-1/2 translate-x-1/2 -z-10"></div>
//         <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-100 rounded-full translate-y-1/2 -translate-x-1/2 -z-10"></div>

//         <div className="general-p-m">
//           <div className="max-w-6xl mx-auto">
//             {/* Section heading for mobile */}
//             <div
//               className="block md:hidden mb-8 text-center"
//               data-aos="fade-up"
//             >
//               <SectionHeading
//                 title={" Become A Volunteer"}
//                 textAlign="center"
//               />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
//               {/* Left: Image */}
//               <div
//                 className="relative h-full flex items-center justify-center rounded-2xl overflow-hidden shadow-lg"
//                 data-aos="fade-right"
//                 data-aos-duration="800"
//               >
//                 <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-orange-50 opacity-80 z-0"></div>
//                 <img
//                   src={volunteer}
//                   alt="Happy volunteers working together"
//                   className="relative z-10 w-full h-full max-h-[500px] object-cover"
//                 />
//               </div>

//               {/* Right: Content */}
//               <div
//                 className="flex flex-col h-full justify-center"
//                 data-aos="fade-left"
//               >
//                 {/* Section heading for desktop */}
//                 <div className="hidden md:block mb-6">
//                   <SectionHeading
//                     title={" Become A Volunteer"}
//                     textAlign="left"
//                   />
//                 </div>

//                 {/* Accordion */}
//                 <div className="flex flex-col gap-4 mb-6">
//                   {volunteerData.map((item, index) => (
//                     <div
//                       key={index}
//                       className={`border rounded-xl p-5 bg-white transition-all duration-300 cursor-pointer hover:shadow-md ${
//                         openIndex === index
//                           ? "border-orange-400 bg-orange-50 shadow-sm"
//                           : "border-gray-200 hover:border-gray-300"
//                       }`}
//                       onClick={() => toggleIndex(index)}
//                     >
//                       <div className="flex items-center justify-between">
//                         <h3
//                           className={`font-semibold transition-colors duration-200 text-lg ${
//                             openIndex === index
//                               ? "text-orange-600"
//                               : "text-gray-800"
//                           }`}
//                         >
//                           {item.title}
//                         </h3>
//                         <div className="flex-shrink-0 ml-3">
//                           {openIndex === index ? (
//                             <FiChevronDown className="text-orange-500 text-xl transition-transform duration-200" />
//                           ) : (
//                             <FiChevronRight className="text-gray-500 text-xl transition-transform duration-200 hover:text-gray-700" />
//                           )}
//                         </div>
//                       </div>

//                       {/* Smooth expanding content */}
//                       <div
//                         className={`overflow-hidden transition-all duration-300 ease-in-out ${
//                           openIndex === index
//                             ? "max-h-40 opacity-100 mt-3"
//                             : "max-h-0 opacity-0 mt-0"
//                         }`}
//                       >
//                         <p className="text-gray-600 leading-relaxed">
//                           {item.description}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Button */}
//                 <div data-aos="fade-up" data-aos-delay="400">
//                   <PrimaryButton
//                     text="Join with us"
//                     onClick={handleJoinClick}
//                     className="whitespace-nowrap py-3 px-8 text-lg font-medium rounded-xl shadow-md hover:shadow-lg transition-shadow"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Modal */}
//       <VolunteerFormModal isOpen={isModalOpen} onClose={handleCloseModal} />
//     </>
//   );
// };

// export default AFSAVolunteers;
